import React, { useState } from 'react';
import { useUsers } from '../context/UserContext';
import './DeliveryBoyAssignmentModal.css';

const DeliveryBoyAssignmentModal = ({ order, onClose, onAssign }) => {
  const { getActiveDeliveryBoys } = useUsers();
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState('');
  const [assigning, setAssigning] = useState(false);

  const deliveryBoys = getActiveDeliveryBoys();

  const handleAssign = async () => {
    if (!selectedDeliveryBoy) {
      alert('Please select a delivery boy');
      return;
    }

    const deliveryBoy = deliveryBoys.find(db => db.id === selectedDeliveryBoy);

    setAssigning(true);
    await onAssign(order.id, {
      deliveryBoyId: deliveryBoy.id,
      deliveryBoyName: deliveryBoy.name,
      deliveryBoyPhone: deliveryBoy.phone
    });
    setAssigning(false);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content delivery-assignment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Assign Delivery Boy</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="order-info-summary">
            <h3>Order #{order.orderNumber || order.id.slice(-4)}</h3>
            <p className="customer-name">Customer: {order.customer?.name}</p>
            <p className="delivery-address">
              <span className="address-icon">📍</span>
              {order.customer?.building && <strong>{order.customer.building}, </strong>}
              {order.customer?.address}
            </p>
          </div>

          {deliveryBoys.length === 0 ? (
            <div className="no-delivery-boys">
              <p className="warning-message">
                <span className="warning-icon">⚠️</span>
                No active delivery boys available. Please add delivery boys in User Management.
              </p>
            </div>
          ) : (
            <div className="delivery-boys-list">
              <label className="select-label">Select Delivery Boy:</label>
              {deliveryBoys.map(deliveryBoy => (
                <label
                  key={deliveryBoy.id}
                  className={`delivery-boy-option ${selectedDeliveryBoy === deliveryBoy.id ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="deliveryBoy"
                    value={deliveryBoy.id}
                    checked={selectedDeliveryBoy === deliveryBoy.id}
                    onChange={(e) => setSelectedDeliveryBoy(e.target.value)}
                  />
                  <div className="delivery-boy-info">
                    <div className="delivery-boy-avatar">
                      {deliveryBoy.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="delivery-boy-details">
                      <span className="delivery-boy-name">{deliveryBoy.name}</span>
                      <span className="delivery-boy-phone">📱 {deliveryBoy.phone}</span>
                    </div>
                  </div>
                  {selectedDeliveryBoy === deliveryBoy.id && (
                    <span className="check-mark">✓</span>
                  )}
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-assign"
            onClick={handleAssign}
            disabled={!selectedDeliveryBoy || assigning || deliveryBoys.length === 0}
          >
            {assigning ? 'Assigning...' : 'Assign & Mark Out for Delivery'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryBoyAssignmentModal;
